import { Ds, SearchSelect } from "@accurx/design";
import { OrganisationOption } from "domains/self-book/utils/types";

type OrganisationProps = {
    options: OrganisationOption[];
    initialOption?: OrganisationOption;
    onChange: (selected: OrganisationOption) => void;
    errors: string[] | undefined;
};

export const ChooseOrganisation = ({
    options,
    initialOption,
    onChange,
    errors,
}: OrganisationProps) => {
    const label = "Organisation";
    const id = "organisation-filter";
    return (
        <Ds.Fieldset>
            <Ds.Legend>{label}</Ds.Legend>
            <SearchSelect
                id={id}
                dimension="medium"
                label={label}
                options={options}
                // Types here are inaccurate, returns Option for single select
                onChangeHandler={(selected) =>
                    onChange(selected as OrganisationOption)
                }
                initSelectedValues={initialOption}
                error={errors && errors.length > 0}
                zIndex={3}
            />
            {errors &&
                errors.map((item) => (
                    <Ds.Form.Error key={item}>{item}</Ds.Form.Error>
                ))}
        </Ds.Fieldset>
    );
};
